<template>
    <v-container>
        <m-form ref="form" autocomplete="disabled">
            <v-row>
                <v-col cols="12" md="3">
                    <m-text-field label="CPF:" id="FieldCpf" :name="generateDynamicName('cpf')" class="required"
                                  :rules="[$rules.required, $rules.cpf]" v-mask="'###.###.###-##'" outlined
                                  v-model="pedido.cliente.cpf" @keyup="handleKeyDownDocumento" @blur="getCliente"
                                  autocomplete="disabled">
                    </m-text-field>
                </v-col>
                <v-col cols="12" md="6">
                    <v-text-field label="Nome completo:" id="FieldNome" :name="generateDynamicName('nome')"
                                  class="required" v-input-filter="model_search.nome_completo || [$filters.text]"
                                  :rules="[$rules.required, $rules.minThreeLetters]" maxlength="150"
                                  v-model="pedido.cliente.nome_completo" outlined v-uppercase
                                  :disabled="model_search.nome_completo" autocomplete="disabled" />
                </v-col>
                <v-col cols="12" md="3">
                    <DateField label="Data de nascimento:" id="FieldData" v-model="pedido.cliente.data_nascimento"
                               :rules="[$rules.required, dataMinima, $rules.dataMaxima150]"
                               :disabled="model_search.data_nascimento" />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-radio-group label="Sexo de nascimento:" id="GroupGenero" class="required"
                                   :rules="[$rules.required]" v-model="pedido.cliente.genero" :disabled="model_search.genero">
                        <v-row>
                            <v-col cols="6">
                                <v-radio label="Feminino" id="RadioFeminino" value="feminino" />
                            </v-col>
                            <v-col cols="6">
                                <v-radio label="Masculino" id="RadioMasculino" value="masculino" />
                            </v-col>
                        </v-row>
                    </v-radio-group>
                </v-col>
                <v-col cols="12" md="4">
                    <MoneyTextField label="Renda:" id="FieldRenda" class="required" outlined :rules="[$rules.required]"
                                    v-model="pedido.cliente.renda" maxlength="14" />
                </v-col>
                <v-col cols="12" md="5">
                    <v-select label="Nacionalidade:" id="SelectNacionalidade" :placeholder="pedido.cliente.nacionalidade ? '' : 'Selecione a nacionalidade'"
                              class="required" outlined @change="limparCidadeNascimento()" :items="nacionalidades"
                              :rules="[$rules.required]" v-model="pedido.cliente.nacionalidade"
                              :clearable="!model_search.nacionalidade" :disabled="model_search.nacionalidade"
                              autocomplete="disabled" />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <m-text-field label="Celular:" id="FieldCelular" ref="celular" class="required" outlined
                                  v-model="pedido.cliente.telefone_celular" v-mask="'(##) #####-####'"
                                  :rules="[$rules.required, $rules.celular]" :name="generateDynamicName('celular')"
                                  autocomplete="disabled" />
                </v-col>
                <v-col cols="12" md="3">
                    <m-text-field label="Telefone fixo:" id="FieldTelefone" outlined
                                  v-model="pedido.cliente.telefone_residencial" v-mask="'(##) ####-####'"
                                  :rules="[$rules.telefone]" :name="generateDynamicName('telefone')" autocomplete="disabled" />
                </v-col>
                <v-col cols="12" md="6">
                    <InputEmail label="E-mail:" id="FieldEmail" class="required" ref="emailField" outlined
                                v-input-filter="[$filters.email]" v-model="pedido.cliente.email"
                                @input="onEmailInput"
                                :rules="[$rules.required, validarEmail]" />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="4">
                    <m-text-field label="RG:" id="FieldRg" class="required" v-validate-rg
                                  :rules="[$rules.required, $rules.minSixCharactersRequired]" maxlength="20"
                                  v-model.trim="pedido.cliente.rg" :disabled="model_search.rg" v-uppercase outlined
                                  :name="generateDynamicName('rg')" autocomplete="disabled" />
                </v-col>
                <v-col cols="12" md="4">
                    <m-text-field label="Órgão expedidor:" id="FieldOrgaoExp" class="required"
                                  v-input-filter="[$filters.orgao_expedidor]" :rules="[$rules.required]" maxlength="20"
                                  v-model="pedido.cliente.orgao_expeditor" outlined v-uppercase
                                  :name="generateDynamicName('orgao_expedidor')" autocomplete="disabled" />
                </v-col>
                <v-col cols="12" md="4">
                    <DateField label="Data de emissão:" id="FieldDataEmissao" :rules="[$rules.dataPassada]"
                               v-model="pedido.cliente.data_emissao" :disabled="model_search.data_emissao" />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <m-text-field label="Nome do pai:" id="FieldNomePai" v-input-filter="[$filters.text]"
                                  maxlength="200" v-model="pedido.cliente.nome_pai" outlined v-uppercase
                                  :name="generateDynamicName('pai')" autocomplete="disabled" />
                </v-col>
                <v-col cols="12" md="6">
                    <m-text-field label="Nome da mãe:" id="FieldNomeMae" class="required"
                                  v-input-filter="model_search.nome_mae || [$filters.text]" :rules="[$rules.required]"
                                  maxlength="200" v-model="pedido.cliente.nome_mae" outlined v-uppercase
                                  :disabled="model_search.nome_mae" :name="generateDynamicName('mae')" autocomplete="disabled" />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="4">
                    <Autocomplete label="Profissão:" id="FieldProfissao" class="required" :rules="[$rules.required]"
                                  url="/profissao/autocomplete" :items="profissoes" v-input-filter="[$filters.textnumeric]"
                                  v-model="pedido.cliente.id_profissao" item-text="nome" item-value="id_profissao"
                                  placeholder="Selecione uma profissão" />
                </v-col>
                <v-col cols="12" md="4">
                    <MoneyTextField label="Patrimônio:" id="FieldPatrimonio" outlined maxvalue="999999999.99"
                                    :disabled="model_search.patrimonio" v-model="pedido.cliente.patrimonio" />
                </v-col>
                <v-col cols="12" md="4">
                    <!--Se é brasileiro seleciona cidade da lista-->
                    <Autocomplete label="Cidade de nascimento:" class="required" id="FieldCidadeNascimento"
                                  :rules="[$rules.required(pedido.cliente.naturalidade), $rules.required(pedido.cliente.id_cidade_nascimento)]"
                                  :items="cidades" url="/cidade/autocomplete" :disabled="block_cidade"
                                  @input="setCidadeSelecionada" :return-object="true" v-model="cidade_selecionada"
                                  item-text="descricao" placeholder="Selecione uma cidade"
                                  v-if="pedido.cliente.nacionalidade !== Nacionalidades.Estrangeira" />
                    <!--Se é estrangeiro digita o nome-->
                    <m-text-field label="Cidade de nascimento:" id="FieldCidadeNaturalidade" class="required"
                                  v-input-filter="[$filters.text]" :rules="[$rules.required]" maxlength="40"
                                  :disabled="model_search.naturalidade" v-model="pedido.cliente.naturalidade" outlined v-uppercase
                                  :name="generateDynamicName('cidade')" autocomplete="disabled"
                                  v-if="pedido.cliente.nacionalidade === Nacionalidades.Estrangeira" />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="4">
                    <v-select label="Estado civil:" id="FieldEstadoCivil" class="required" outlined
                              :items="estados_civis" item-text="nome" item-value="id_estado_civil"
                              :placeholder="pedido.cliente.id_estado_civil ? '' : 'Selecione o estado civil'" :rules="[$rules.required]"
                              v-model="pedido.cliente.id_estado_civil" autocomplete="disabled" />
                </v-col>
                <v-col cols="12" md="4" v-if="pedido.cliente.id_estado_civil === id_estado_civil_casado">
                    <m-text-field label="CPF do cônjuge:" id="FieldCpfConjuge" class="required"
                                  :rules="[$rules.required, $rules.cpf]" v-mask="'###.###.###-##'" outlined
                                  v-model="pedido.cliente.cpf_conjuge" @blur="checkConjuge"
                                  :name="generateDynamicName('cpf_conjuge')" autocomplete="disabled">
                    </m-text-field>
                </v-col>
                <v-col cols="12" md="4" v-if="pedido.cliente.id_estado_civil === id_estado_civil_casado">
                    <m-text-field label="Nome do cônjuge:" id="FieldNomeConjuge" class="required"
                                  v-input-filter="model_search.nome_conjuge || [$filters.text]" :rules="[$rules.required]"
                                  maxlength="200" v-model="pedido.cliente.nome_conjuge" outlined v-uppercase
                                  :disabled="model_search.nome_conjuge" :name="generateDynamicName('nome_conjuge')"
                                  autocomplete="disabled" />
                </v-col>
            </v-row>
            <PoliticamenteExposto v-model="pedido.cliente" />
        </m-form>
        <v-row class="justify-space-between mt-8">
            <v-btn v-if="fluxoProduto" id="ButtonVoltar" color="secondary" text @click="prev()">
                Voltar
            </v-btn>
            <v-col class="text-center red--text mb-4">
                Campos obrigatórios *
            </v-col>
            <template v-if="bloqueado_newcon == 1">
                <v-tooltip left
                           max-width="300px"
                           color="lightgray"
                           nudge-top="50"
                           nudge-right="8"
                >
                    <template #activator="{ on, attrs }">
                        <div v-on="on" v-bind="attrs" style="display: flex;">
                            <v-btn id="ButtonContinuar" color="primary" @click="openDialog" :disabled="bloqueado_newcon == 1">
                                Continuar
                            </v-btn>
                        </div>
                    </template>
                    <div class="d-flex align-center">
                        <span style="color: var(--primary)" class="font-weight-bold text-left">Cliente bloqueado para realizações de compras na Administradora.</span>
                    </div>
                </v-tooltip>
            </template>
            <template v-else>
                <v-btn id="ButtonContinuar" color="primary" @click="openDialog">
                    Continuar
                </v-btn>
            </template>
        </v-row>
        <DialogConfirmarAlterarEmail v-model="dialogEmailOpen" :email="pedido.cliente.email"
                                     @confirmar="handleEmailConfirmed" @alterar="focus" />
    </v-container>
</template>
ss
<script>
  import { get, isEmpty, isNil, isString, omit, merge } from 'lodash'
  import moment from 'moment'
  import { notification, limparEspacosAsteriscos } from '@/plugins/helpers'
  import { validaCPF, minimumAge } from '@/plugins/validation'
  import { EstadoCivil, Nacionalidades, TipoPessoa, TipoTelefone } from '@/plugins/constants'
  import { toDateBR } from '@/plugins/formatters'
  import { tokens } from 'vue-the-mask'
  import masker from 'vue-the-mask/src/masker'
  import PoliticamenteExposto from '@/views/cadastro/cliente/PoliticamenteExposto'
  import { sendAnalyticsEvent } from '@/plugins/googleAnalytics'
  import { mapState } from 'vuex'
  import { AlertTypes } from '../../../plugins/alerts_types'
  import DialogConfirmarAlterarEmail from '../../../dialogs/DialogConfirmarAlterarEmail.vue'
  import emailMixin from '../../../mixins/emailMixin'
  import InputEmail from '../../../components/inputs/InputEmail.vue'
  import dynamicNameMixin from '../../../mixins/dynamicNameMixin'
  import { ClientDataErrorMessages } from '../../../enums/client/messages'
  import { formatRG } from '../../../plugins/formatters'

  const idEstadoCivilCasado = 1
  const clienteDefault = () => ({
    bloqueado: false,
    pessoa: TipoPessoa.Fisica,
    politicamente_exposto: null,
    id_parentesco: null,
    id_pessoa_erp: null,
    id_cargo_politico: null,
    genero: null,
    data_nascimento: '',
    nacionalidade: '',
    nome_completo: '',
    cpf: '',
    renda: 0,
    telefone_residencial: '',
    telefone_celular: '',
    email: '',
    rg: '',
    orgao_expeditor: '',
    data_emissao: '',
    nome_pai: '',
    nome_mae: '',
    id_profissao: null,
    patrimonio: 0,
    id_cidade_nascimento: null,
    naturalidade: '',
    id_estado_civil: null,
    nome_conjuge: '',
    cpf_conjuge: '',
    id_cliente: null
  })
  const newConClienteMap = {
    NM_Pessoa: {
      key: 'nome_completo',
      value: val => val
    },
    DT_Nascimento: {
      key: 'data_nascimento',
      value: val => val
    },
    ST_Sexo: {
      key: 'genero',
      value: val => val === 'F' || val === 'feminino' ? 'feminino' : 'masculino'
    },
    VL_Renda: {
      key: 'renda',
      value: val => val > 0 ? val.toFixed(2) : ''
    },
    NM_Nacionalidade: {
      key: 'nacionalidade',
      value: val => typeof val !== 'undefined' ? val.trim() : ''
    },
    ID_Profissao: {
      key: 'id_profissao',
      value: val => val !== 0 ? val : null
    },
    ID_Estado_Civil: {
      key: 'id_estado_civil',
      value: val => val
    },
    NM_Mae: {
      key: 'nome_mae',
      value: val => val
    },
    NM_Pai: {
      key: 'nome_pai',
      value: val => val
    },
    NO_Documento: {
      key: 'rg',
      value: val => val
    },
    NM_Orgao_Emissor: {
      key: 'orgao_expeditor',
      value: val => val
    },
    DT_Expedicao: {
      key: 'data_emissao',
      value: val => val
    },
    VL_Patrimonio_Total: {
      key: 'patrimonio',
      value: val => val
    },
    Naturalidade: {
      key: 'naturalidade',
      value: val => val
    }
  }
  const newConConjugeMap = {
    NM_Pessoa: {
      key: 'nome_conjuge',
      value: val => val
    },
    CD_Inscricao_Nacional: {
      key: 'cpf_conjuge',
      value: val => val
    }
  }

  export default {
    name: 'Fisica',
    components: { PoliticamenteExposto, DialogConfirmarAlterarEmail, InputEmail },
    mixins: [emailMixin, dynamicNameMixin],
    props: {
      value: { type: Object }
    },
    data: () => ({
      dialogEmailOpen: false,
      cidade_selecionada: null,
      ultimoDocumentoInserido: null,
      nacionalidades: [Nacionalidades.Brasileira, Nacionalidades.Estrangeira],
      pedido: {
        cliente: clienteDefault()
      },
      block_cidade: false,
      finalizouFluxoTela: false,
      model_search: {
        genero: false,
        data_nascimento: false,
        nacionalidade: false,
        nome_completo: false,
        id_profissao: false,
        nome_mae: false,
        nome_conjuge: false,
        data_emissao: false,
        naturalidade: false,
        rg: false
      },
      check_bloquear_campo: {
        genero: true,
        data_nascimento: true,
        nacionalidade: true,
        nome_completo: true,
        id_profissao: true,
        nome_mae: true,
        nome_conjuge: true,
        data_emissao: true,
        naturalidade: false,
        rg: true
      },
      cidades: [],
      profissoes: [],
      estados_civis: [],
      opcoes_politicamente_exposto: [],
      parentescos: [],
      cargos: [],
      configuracao_idade: 16,
      percentual_minimo_venda: 0,
      bloqueado_newcon: 0
    }),
    computed: {
      ...mapState(['id_usuario', 'jornada_venda']),
      fluxoProduto () {
        return this.$route.name === 'iniciar-venda'
      },
      id_estado_civil_casado: () => idEstadoCivilCasado,
      Nacionalidades: () => Nacionalidades
    },
    watch: {
      value () {
        this.update()
      },
      'value.cliente' (cliente) {
        if (this.finalizouFluxoTela) {
          return
        }
        Object.assign(this.pedido.cliente, cliente)

        if (this.pedido.cliente.bloqueado) {
          Object.keys(this.model_search).forEach(key => {
            if (key === 'nome_conjuge') return
            const val = this.pedido.cliente[key]

            if (key === 'nacionalidade') {
              this.model_search[key] = !isEmpty(val.trim()) && (val === Nacionalidades.Brasileira || val === Nacionalidades.Estrangeira)
            } else {
              if (this.check_bloquear_campo[key]) {
                this.model_search[key] = !!this.pedido.cliente[key]
              }
            }
          })
        }
      },
      'pedido.cliente.id_estado_civil' (val) {
        if (val !== this.id_estado_civil_casado) {
          this.pedido.cliente.cpf_conjuge = ''
          this.pedido.cliente.nome_conjuge = ''
          this.model_search.nome_conjuge = false
        }
      }
    },
    mounted () {
      this.id_usuario_interno = this.$session.get('id_usuario_interno')
    },
    methods: {
      setCidadeSelecionada (value) {
        if (!value || !value.id_cidade) {
          this.pedido.cliente.id_cidade_nascimento = null
          this.pedido.cliente.naturalidade = ''
          return
        }
        this.pedido.cliente.id_cidade_nascimento = value.id_cidade || null
        this.pedido.cliente.naturalidade = value.nome || ''
      },
      toDateBR (val) {
        return val.includes('-') ? toDateBR(val) : val
      },
      update () {
        if (this.finalizouFluxoTela) {
          return
        }
        if (this.value.backing_register) {
          this.pedido = merge({}, this.pedido, this.value)
        } else {
          this.pedido = merge({}, this.value, this.pedido)
        }
        this.ultimoDocumentoInserido = this.pedido.cliente.cpf
        this.value.backing_register = false
        this.pedido.backing_register = false

        if (this.pedido.cliente.renda) {
          this.pedido.cliente.renda = parseFloat(this.value.cliente.renda).toFixed(2)
        }

        if (this.pedido.cliente.id_cidade_nascimento && (this.cidades.length === 0 || this.cidades[0].id_cidade !== this.pedido.cliente.id_cidade_nascimento)) {
          this.getCidade(this.pedido.cliente.id_cidade_nascimento, true)
        }

        this.getProfissao(this.pedido.cliente.id_profissao)

        if (this.pedido.cliente.bloqueado) {
          Object.keys(this.model_search).forEach(key => {
            const val = this.pedido.cliente[key]

            if (key === 'nacionalidade') {
              this.model_search[key] = !isEmpty(val.trim()) && (val === Nacionalidades.Brasileira || val === Nacionalidades.Estrangeira)
            } else {
              if (this.check_bloquear_campo[key]) {
                this.model_search[key] = !isNil(val) && (!isString(val) || !isEmpty(val))
              }
            }
          })
        }
        Promise.all([
          this.getEstadosCivis(),
          this.loadConfiguracaoIdade(),
          this.getLimiteComprometimentoRendaWithRetry()
        ]).catch(err => {
          console.error('[Fisica.vue] Erro ao carregar configurações iniciais:', err)
        })
      },
      handleKeyDownDocumento (event) {
        if (this.ultimoDocumentoInserido !== event.target.value) {
          this.reset(true)
        }
      },
      resetUltimoDocumento () {
        this.ultimoDocumentoInserido = null
      },
      reset (resetaNaoBloqueado = false) {
        if (this.pedido.cliente.bloqueado || resetaNaoBloqueado) {
          this.ultimoDocumentoInserido = null
          this.block_cidade = false
          this.pedido.cliente.bloqueado = false
          this.limparDados()
          this.desbloquearCampos()
          this.cidade_selecionada = null
          this.profissoes = []
        }
      },
      async next () {
        let id_empresa = this.$session.get('id_empresa')
        const form = this.$refs.form

        this.pedido.cliente.id_usuario = this.id_usuario_interno
        this.pedido.id_empresa = this.pedido.id_empresa >= 1 ? this.pedido.id_empresa : id_empresa
        this.pedido.id_empresa_venda_logada = id_empresa
        this.pedido.id_unidade_negocio = this.$session.get('id_unidade_negocio')
        this.pedido.cliente.pessoa = TipoPessoa.Fisica
        if ((typeof this.pedido.vl_parcela !== 'undefined' && this.pedido.vl_parcela && this.percentual_minimo_venda > 0) || (typeof this.pedido.politica_vendas !== 'undefined' && this.pedido.politica_vendas && this.percentual_minimo_venda > 0)) {
          let parcela = typeof this.pedido.politica_vendas !== 'undefined' && this.pedido.politica_vendas ? this.pedido.plano.valor_parcela : this.pedido.vl_parcela
          let renda = this.pedido.cliente.pessoa === 'fisica' ? this.pedido.cliente.renda : this.pedido.cliente.faturamento_medio
          let resul = (parcela / renda) * 100
          if (resul > this.percentual_minimo_venda) {
            return notification('warning', 'O valor da parcela selecionada compromete mais do que ' + this.percentual_minimo_venda + '% da renda, venda não permitida.')
          }
        }
        if (form.validate()) {
          this.sendAnalytics()
          this.$http.post('/clientes', this.pedido.cliente)
            .then((result) => {
              this.finalizouFluxoTela = true
              this.pedido.cliente = { ...this.pedido.cliente, ...result.data }
              this.$emit('input', this.pedido)
              this.$emit('nextPage')
            })
            .catch(() => {
              this.finalizouFluxoTela = false
              notification('error', 'Foi encontrado um erro ao salvar os dados do cliente, caso o erro continue, entre em contato com a Área de Suporte')
            })
        }
      },
      sendAnalytics () {
        sendAnalyticsEvent(this.$gtag, 'cadastro_pessoa', {
          tipo_pessoa: 'PF',
          data_nascimento: this.pedido.cliente.data_nascimento,
          sexo_nascimento: this.pedido.cliente.genero,
          renda: this.pedido.cliente.renda,
          nacionalidade: this.pedido.cliente.nacionalidade,
          profissao: this.pedido.cliente.id_profissao,
          patrimonio: this.pedido.cliente.patrimonio,
          cidade_nascimento: this.pedido.cliente.id_cidade_nascimento,
          estado_civil: this.pedido.cliente.id_estado_civil,
          condicao_politica: this.pedido.cliente.politicamente_exposto,
          cargo: this.pedido.cliente.id_cargo_politico,
          source_menu: this.jornada_venda,
          cadastro_existente: this.pedido.cliente.bloqueado ? 'Sim' : 'Não'
        })
      },
      loadConfiguracaoIdade () {
        return this.$http.get('/configuracaoidade/get')
          .then(result => {
            if (result.data) {
              this.configuracao_idade = result.data.valor_idade
            }
          })
          .catch(err => console.error(err))
      },
      async getCliente () {
        if (!validaCPF(this.pedido.cliente.cpf)) {
          return
        }
        if (this.pedido.cliente.cpf === this.ultimoDocumentoInserido) {
          return
        }
        this.check_bloquear_campo.nome_completo = true
        this.ultimoDocumentoInserido = this.pedido.cliente.cpf

        this.bloqueado_newcon = 0
        this.block_cidade = false
        const pessoaFisicaIntermediariaResponse = await this.$http.get('/pessoa_base', { params: { CD_Inscricao_Nacional: this.pedido.cliente.cpf, tipo_pessoa: 'fisica' } })
        this.pedido.id_cliente = pessoaFisicaIntermediariaResponse.data.id_cliente
        let pessoaFisicaResponse
        try {
          pessoaFisicaResponse = await this.$http.get('/clientes/pessoafisica', { params: { CD_Inscricao_Nacional: this.pedido.cliente.cpf, cliente: true } })
        } catch (error) {
          if (error.response?.status === 409) {
            this.bloqueado_newcon = error.response.data.bloqueado_newcon
            notification(AlertTypes.WARN, error.response?.data?.error)
          } else {
            notification(AlertTypes.ERROR, error.response?.data?.error)
          }
        }
        if (pessoaFisicaResponse && pessoaFisicaResponse.data && pessoaFisicaResponse.data.ID_Pessoa) {
          const pessoaFisica = pessoaFisicaResponse.data
          this.pedido.cliente.bloqueado = true

          if (pessoaFisica.msgStack) {
            for (let mensagem of pessoaFisica.msgStack) {
              const mensagemPersonalizada = mensagem.message.replaceAll('{value}', 'Cliente')
              if (mensagem.message.includes('{value}')) {
                this.check_bloquear_campo.nome_completo = false
              }

              const startPaused = mensagem.type === 'warning'
              notification(mensagem.type, mensagemPersonalizada, '', false, false, startPaused)
            }
          }

          if (pessoaFisica.CD_Inscricao_Nacional_Conjuge && pessoaFisica.ID_Estado_Civil === EstadoCivil.casado) {
            let conjugeResponse
            try {
              conjugeResponse = await this.$http.get('/clientes/pessoafisica', { params: { CD_Inscricao_Nacional: pessoaFisica.CD_Inscricao_Nacional_Conjuge, conjuge: true } })
            } catch (error) {
              if (error.response?.status === 409) {
                this.bloqueado_newcon = error.response.data.bloqueado_newcon
                notification(AlertTypes.WARN, error.response?.data?.error)
              } else {
                notification(AlertTypes.ERROR, error.response?.data?.error)
              }
            }
            if (conjugeResponse && conjugeResponse.data && conjugeResponse.data.ID_Pessoa) {
              const conjuge = conjugeResponse.data
              this.pedido.cliente.nome_conjuge = conjuge.NM_Pessoa
              this.pedido.cliente.cpf_conjuge = conjuge.CD_Inscricao_Nacional
            }
          }

          const telefonesResponse = await this.$http.get('/clientes/telefone', { params: { ID_Pessoa: pessoaFisica.ID_Pessoa } })
          const telefones = get(telefonesResponse, 'data.TelefonePessoa.stcTelefonePessoa', [])
          const telefones_celular = telefones.filter(telefone => telefone.ID_Tipo_Telefone === TipoTelefone.telefone_celular)
          const telefones_residencial = telefones.filter(telefone => telefone.ID_Tipo_Telefone !== TipoTelefone.telefone_celular)
          this.setTelefone(telefones_celular, 'telefone_celular')
          this.setTelefone(telefones_residencial, 'telefone_residencial')

          const emailResponse = await this.$http.get('/clientes/email', { params: { ID_Pessoa: pessoaFisica.ID_Pessoa } })
          if (emailResponse && emailResponse.data && typeof emailResponse.data.E_Mail !== 'undefined') {
            this.pedido.cliente.email = emailResponse.data.E_Mail
          }

          this.update()

          const shouldKeepNomeCompletoUnlocked = !this.check_bloquear_campo['nome_completo']
          const pessoaFisicaFinal = await this.checkCamposClienteFisica(pessoaFisica, pessoaFisicaIntermediariaResponse.data)
          if (shouldKeepNomeCompletoUnlocked) {
            this.check_bloquear_campo.nome_completo = false
          }

          this.$emit('loadCliente', pessoaFisicaFinal, newConClienteMap)
          if (pessoaFisica.CD_Inscricao_Nacional_Conjuge) {
            await this.getConjuge(pessoaFisica.CD_Inscricao_Nacional_Conjuge, false)
          }

          if (!pessoaFisicaResponse.data.idade_permitida) {
            notification('warning', 'A idade minima é ' + this.configuracao_idade + ' anos')
            this.desbloquearCampos()
            Object.assign(this.pedido.cliente, clienteDefault())
            this.pedido.cliente.renda = null
          }
        } else if (pessoaFisicaIntermediariaResponse.data.id_cliente > 0) {
          const pessoaFisicaFinal = await this.checkCamposClienteFisica(false, pessoaFisicaIntermediariaResponse.data)
          this.$emit('loadCliente', pessoaFisicaFinal, newConClienteMap)
        } else {
          this.reset()
        }
      },
      async setTelefone (telefones, tipoTelefone) {
        if (!isEmpty(telefones)) {
          const telefone = telefones.reduce((lastValue, currentValue) => lastValue.ID_Telefone > currentValue.ID_Telefone ? lastValue : currentValue)
          const cidade = await this.$http.get(`/clientes/telefone/ddd/${telefone.ID_Cidade}`)
          this.pedido.cliente[tipoTelefone] = this.maskTelefone(cidade.data.ddd, telefone.Telefone)
        }
      },
      async getConjuge (cpf, mensagemConjuge = true) {
        this.bloqueado_newcon = 0
        this.$http.get('/clientes/pessoafisica', { params: { CD_Inscricao_Nacional: cpf, conjuge: true } })
          .then(({ data }) => {
            if (data['ID_Pessoa']) {
              if (data.CD_Inscricao_Nacional) {
                data.CD_Inscricao_Nacional = masker(`${data.CD_Inscricao_Nacional}`, '###.###.###-##', true, tokens)
                this.model_search.nome_conjuge = true
              }

              if (data.msgStack) {
                for (let mensagem of data.msgStack) {
                  const mensagemPersonalizada = mensagem.message.replaceAll('{value}', 'Cônjuge')
                  const startPaused = mensagem.type === 'warning'
                  notification(mensagem.type, mensagemPersonalizada, '', false, false, startPaused)
                  if (mensagem.type === 'warning' && mensagem.message.includes('{value}')) {
                    this.model_search.nome_conjuge = false
                  }
                }
              }
              this.$emit('loadCliente', data, newConConjugeMap)
            } else {
              this.model_search.nome_conjuge = false
              this.pedido.cliente.nome_conjuge = ''
              if (mensagemConjuge) {
                notification('warning', 'Não foi possível encontrar o cônjuge do cliente informado. Por favor, preencha os dados manualmente')
              }
              this.$refs.form.resetValidation()
            }
          })
          .catch((error) => {
            if (error.response?.status === 409) {
              this.model_search.nome_conjuge = false
              this.pedido.cliente.nome_conjuge = ''
              this.bloqueado_newcon = error.response.data.bloqueado_newcon
              notification(AlertTypes.WARN, error.response?.data?.error)
            } else {
              notification('error', error, 'Não foi possível encontrar o cônjuge do cliente informado. Por favor, preencha os dados manualmente')
            }
          })
      },
      resetForm () {
        this.$refs.form.resetValidation()
      },
      getCidade (id_cidade, from_newcon = false) {
        this.cidades = []
        return this.$http.get(`cidade/${id_cidade}`)
          .then(result => {
            this.cidades = [result.data]
            this.cidade_selecionada = { ...result.data }
            if (from_newcon) {
              this.block_cidade = true
              this.checkNacionalidadeVaziaNewcon()
            }
          })
          .catch(() => {
            this.cidade_selecionada = null
            this.block_cidade = false
            notification('warning', 'Não foi possível buscar a cidade cadastrada do cliente')
          })
      },
      maskTelefone (ddd, telefone) {
        return masker(`${ddd}${telefone}`, ['(##) ####-####', '(##) #####-####'], true, tokens)
      },
      isReservaCompleta () {
        return this.pedido.reserva && this.pedido.reserva.completa
      },
      getProfissao (id_profissao) {
        if (id_profissao) {
          this.profissoes = []
          this.$http.get(`/profissao/${id_profissao}`)
            .then(res => {
              this.profissoes = res.data
            })
            .catch(() => {
              this.endereco.id_cidade = null
              notification('warning', 'Não foi possível buscar a profissão cadastrada do cliente')
            })
        }
      },
      getEstadosCivis () {
        return this.$http.get('/estadoscivis')
          .then(res => {
            this.estados_civis = res.data
          })
      },
      limparCidadeNascimento () {
        this.pedido.cliente.id_cidade_nascimento = null
        this.pedido.cliente.naturalidade = ''
      },
      limparEDesbloquearCidadeNascimento () {
        this.limparCidadeNascimento()
        this.cidade_selecionada = null
        this.block_cidade = false
      },
      limparDados () {
        Object.assign(this.pedido.cliente, omit(clienteDefault(), 'cpf'))
      },
      limparConjuge () {
        if (this.model_search.nome_conjuge) {
          this.model_search.nome_conjuge = false
          this.pedido.cliente.nome_conjuge = ''
        }
      },
      desbloquearCampos () {
        Object.keys(this.model_search).forEach(key => {
          this.model_search[key] = false
        })
      },
      checkConjuge () {
        if (!this.pedido.cliente.cpf_conjuge) {
          return
        }

        if (this.pedido.cliente.cpf !== '' && this.pedido.cliente.cpf_conjuge !== '' && this.pedido.cliente.cpf === this.pedido.cliente.cpf_conjuge) {
          notification('warning', 'O CPF do Conjugê não pode ser igual ao CPF do cliente.')
          this.pedido.cliente.cpf_conjuge = 0
          return false
        } else {
          this.getConjuge(this.pedido.cliente.cpf_conjuge, false)
        }
      },
      dataMinima (v) {
        let msg_erro = ('A idade minima é ' + this.configuracao_idade + ' anos')
        return (!v || !(v && moment(v, 'DD/MM/YYYY').isAfter(moment(minimumAge(parseInt(this.configuracao_idade))))) || msg_erro)
      },
      prev () {
        this.$emit('prevPage')
      },
      checkNacionalidadeVaziaNewcon () {
        if ((this.pedido.cliente.nacionalidade.length === 0 ||
          ![Nacionalidades.Brasileira, Nacionalidades.Estrangeira].includes(this.pedido.cliente.nacionalidade)) &&
          this.pedido.cliente.id_cidade_nascimento > 0) {
          this.pedido.cliente.nacionalidade = Nacionalidades.Brasileira
          this.model_search.nacionalidade = true
        }
      },
      checkIsRGValid (rg) {
        if (!rg) {
          return false
        }
        const rgSemCaracteresEspeciais = rg.replace(/[^a-zA-Z0-9]/g, '')

        if (rg !== rgSemCaracteresEspeciais) {
          notification(AlertTypes.ERROR, ClientDataErrorMessages.SPECIAL_CHARACTERS)
          return false
        }

        if (rg.length < 6) {
          notification(AlertTypes.ERROR, ClientDataErrorMessages.LENGTH_NOT_SUFFICE)
          return false
        }

        if (rg.length > 20) {
          notification(AlertTypes.ERROR, ClientDataErrorMessages.LENGTH_EXCEEDED)
          return false
        }

        if (rg.length > 2) {
          const lettersInInvalidPositions = rg.slice(0, rg.length - 2).match(/[A-Za-z]/)
          if (lettersInInvalidPositions) {
            notification(AlertTypes.ERROR, ClientDataErrorMessages.INVALID_LETTERS_POSITION)
            return false
          }
        }

        return true
      },
      async checkCamposClienteFisica (pessoaNewcon, pessoaBase) {
        let pessoa_final = pessoaNewcon === false ? [] : pessoaNewcon

        if (pessoaNewcon) {
          this.pedido.cliente.bloqueado = true
        }

        Object.keys(this.check_bloquear_campo).forEach(key => {
          this.check_bloquear_campo[key] = true
        })

        this.pedido.cliente.id_cliente = pessoaBase.id_cliente > 0 ? pessoaBase.id_cliente : null

        if (!pessoaNewcon) {
          this.pedido.cliente.id_pessoa_erp = null
        }

        if (!pessoaNewcon && pessoaBase.id_usuario !== this.id_usuario_interno) {
          return []
        }

        if ((!pessoaNewcon || pessoa_final['NM_Pessoa'] === '') && pessoaBase.nome_cliente !== '') {
          pessoa_final['NM_Pessoa'] = pessoaBase.nome_completo
          this.check_bloquear_campo['nome_completo'] = false
        }

        if ((!pessoaNewcon || pessoa_final['DT_Nascimento'] === '') && pessoaBase.data_nascimento !== '') {
          pessoa_final['DT_Nascimento'] = pessoaBase.data_nascimento
          this.check_bloquear_campo['data_nascimento'] = false
        }

        if ((!pessoaNewcon || pessoa_final['ST_Sexo'] === '') && pessoaBase.genero !== '') {
          pessoa_final['ST_Sexo'] = pessoaBase.genero
          this.check_bloquear_campo['genero'] = false
        }

        if ((!pessoaNewcon || pessoa_final['VL_Renda'] === '') && pessoaBase.renda !== '') {
          pessoa_final['VL_Renda'] = pessoaBase.renda
        }

        if ((!pessoaNewcon || pessoa_final['NM_Nacionalidade'] === '') && pessoaBase.nacionalidade !== '') {
          pessoa_final['NM_Nacionalidade'] = pessoaBase.nacionalidade
          this.check_bloquear_campo['nacionalidade'] = false
        }

        if (this.pedido.cliente.email === '' && pessoaBase.email !== '') {
          this.pedido.cliente.email = pessoaBase.email
        }

        this.check_bloquear_campo['rg'] = this.checkIsRGValid(pessoa_final['NO_Documento'])
        if ((!pessoaNewcon || pessoa_final['NO_Documento'] === '') && pessoaBase.rg !== '') {
          pessoa_final['NO_Documento'] = pessoaBase.rg
        }
        this.pedido.cliente.rg = formatRG(pessoa_final['NO_Documento'])

        if ((!pessoaNewcon || pessoa_final['NM_Orgao_Emissor'] === '') && pessoaBase.orgao_expeditor !== '') {
          pessoa_final['NM_Orgao_Emissor'] = pessoaBase.orgao_expeditor
        }

        if ((!pessoaNewcon || pessoa_final['DT_Expedicao'] === '') && pessoaBase.data_emissao !== '') {
          pessoa_final['DT_Expedicao'] = pessoaBase.data_emissao
          this.check_bloquear_campo['data_emissao'] = false
        }
        if (pessoa_final['DT_Expedicao'] === '01/01/****') {
          pessoa_final['DT_Expedicao'] = pessoaBase.data_emissao
          this.check_bloquear_campo['data_emissao'] = false
        }

        pessoa_final['NM_Pai'] = pessoaBase.nome_pai

        if ((!pessoaNewcon || limparEspacosAsteriscos(pessoa_final['NM_Mae']) === '') && limparEspacosAsteriscos(pessoaBase.nome_mae) !== '') {
          pessoa_final['NM_Mae'] = pessoaBase.nome_mae
          this.check_bloquear_campo['nome_mae'] = false
        } else if ((!pessoaNewcon || limparEspacosAsteriscos(pessoa_final['NM_Mae']) === '')) {
          pessoa_final['NM_Mae'] = ''
          this.check_bloquear_campo['nome_mae'] = false
        }

        if ((!pessoaNewcon || pessoa_final['ID_Profissao'] === '') && pessoaBase.id_profissao !== '') {
          this.getProfissao(pessoaBase.id_profissao)
          pessoa_final['ID_Profissao'] = pessoaBase.id_profissao
          this.check_bloquear_campo['id_profissao'] = false
        } else {
          this.getProfissao(pessoa_final['ID_Profissao'])
        }

        if ((!pessoaNewcon || pessoa_final['VL_Patrimonio_Total'] === '' || pessoa_final['VL_Patrimonio_Total'] <= 0) && pessoaBase.patrimonio > 0) {
          pessoa_final['VL_Patrimonio_Total'] = pessoaBase.patrimonio
        }

        if ((!pessoaNewcon || pessoa_final['Naturalidade'] === '')) {
          if (pessoaBase.naturalidade !== '') {
            pessoa_final['Naturalidade'] = pessoaBase.naturalidade
          }
          this.check_bloquear_campo['naturalidade'] = false
        }

        if ((!pessoaNewcon || pessoa_final['ID_Estado_Civil'] === '') && pessoaBase.id_estado_civil !== '') {
          pessoa_final['ID_Estado_Civil'] = pessoaBase.id_estado_civil
        }

        let id_cidade_busca = 0
        let from_newcon = false

        if (this.$session.get('procura_cidade_por_id')) {
          if (pessoaNewcon && pessoaNewcon['ID_Cidade_Naturalidade']) {
            id_cidade_busca = pessoaNewcon['ID_Cidade_Naturalidade']
            if (id_cidade_busca > 0) {
              from_newcon = true
            }
          }
        } else {
          if (pessoaNewcon && pessoaNewcon['Naturalidade']) {
            id_cidade_busca = await this.getIdCidadeByName(pessoaNewcon['Naturalidade'])
            if (id_cidade_busca > 0) {
              from_newcon = true
            }
          }
        }

        if (pessoaBase.id_cidade_nascimento > 0 && !from_newcon) {
          id_cidade_busca = pessoaBase.id_cidade_nascimento
        }

        if (id_cidade_busca > 0) {
          this.pedido.cliente.id_cidade_nascimento = id_cidade_busca
          this.getCidade(id_cidade_busca, from_newcon)
        }

        this.pedido.cliente.politicamente_exposto = pessoaBase.politicamente_exposto
        this.pedido.cliente.id_cargo_politico = pessoaBase.id_cargo_politico
        this.pedido.cliente.id_parentesco = pessoaBase.id_parentesco
        this.pedido.cliente.cpf_conjuge = pessoaBase.cpf_conjuge
        this.pedido.cliente.nome_conjuge = pessoaBase.nome_conjuge

        if (!pessoaNewcon) {
          this.pedido.cliente.telefone_celular = pessoaBase.telefone_celular
          this.pedido.cliente.telefone_residencial = pessoaBase.telefone_residencial
          this.pedido.cliente.telefone_comercial = pessoaBase.telefone_comercial
        }

        return pessoa_final
      },
      async getLimiteComprometimentoRendaWithRetry () {
        let retryCount = 0
        const maxRetries = 3

        if ((typeof this.pedido.vl_parcela !== 'undefined' && this.pedido.vl_parcela) ||
          (typeof this.pedido.politica_vendas !== 'undefined' && this.pedido.politica_vendas)) {
          while (retryCount < maxRetries) {
            try {
              const result = await this.$http.get(`/parametrizacao/load_parametrizacao/limite_comprometimento_renda`)
              if (result.data) {
                this.percentual_minimo_venda = result.data.valor
                return
              }
            } catch (err) {
              console.error('[getLimiteComprometimentoRendaWithRetry] Tentativa falhou:', retryCount + 1, err)
            }
            retryCount++
          }
        }
        // Se não conseguiu obter o limite após as tentativas, apenas loga e continua
        console.warn('[getLimiteComprometimentoRendaWithRetry] Não foi possível obter o limite de comprometimento de renda após', maxRetries, 'tentativas. O sistema continuará sem esse valor.')
      },
      async getIdCidadeByName (nome_cidade) {
        return this.$http.get(`/cidade_by_name/${nome_cidade}`)
          .then(result => {
            return result.data
          })
          .catch(() => {
            return 0
          })
      }
    }

  }
</script>
<style scoped>
  .fade-expand-enter-active, .fade-expand-leave-active {
    transition: all 0.3s ease; opacity: 1; overflow: hidden;
  }
  .fade-expand-enter, .fade-expand-leave-to {
     opacity: 0; margin-top: 0 !important;
  }
</style>
